import React from 'react';
import { appSettings } from '../../helpers/settings';
import { HiOutlinePresentationChartBar } from 'react-icons/hi';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';

function RecentFundraises() {
    return (
        <>
            <section className='py-5 bg-dark'>
                <div className='container py-5'>
                    <div className='row g-5 align-items-center'>
                        <div className='col-lg-6 text-center'>
                            <div className='d-inline-block'>
                                <div className='oval-holder'>
                                    <img src='/about-img.png' alt='About us' className='img-fluid oval' width='400' />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-6'>
                            <p className='h4 mb-0 text-primary'>Get to Know {appSettings.brandName}</p>
                            <h2 className='h1'>Why Choose Restifi?</h2>
                            <p className='text-muted mb-4'>
                            At Restifi, we streamline your journey, offering you unparalleled access to global private market opportunities. Here's why savvy investors trust us:
                            </p>

                            <div className='row'>
                                <div className='col-xl-8'>
                                    <ul className='list-unstyled'>
                                        <li className='d-flex align-items'>
                                            <div className='icon icon-lg'>
                                                <HiOutlinePresentationChartBar size={25} />
                                            </div>
                                            <div className='ms-3'>
                                                <h5>Maximize Your Profits:</h5>
                                                <p className='text-sm text-muted'>
                                                        <b>Leveraged Returns:</b> Amplify your potential returns using the power of leverage.
                                                </p>
                                            </div>
                                        </li>
                                        <li className='d-flex align-items'>
                                            <div className='icon icon-lg'>
                                                <RiMoneyDollarCircleLine size={25} />
                                            </div>
                                            <div className='ms-3'>
                                                <h5>Unmatched Liquidity:</h5>
                                                <p className='text-sm text-muted'>
                                                <b>Easy Token Sales:</b> Trade your tokens on the secondary market. Cash out whenever you wish.<br/>
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default RecentFundraises;
